<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('content-key')"
          prop="contentKey"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.contentKey"
            @input="inputContentKey"
            :disabled="disabledContentKey"
            @change="updateModelItem('contentKey', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('title')"
          prop="title"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            :value="form.title"
            @input="form.title = valueTrimLeft($event)"
            @change="updateModelItem('title', { required: true })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('html-1')"
          prop="html1"
          class="material-style"
        >
          <skill-editor
            :model.sync="form.html1"
            @blur="updateModelItem('html1', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-6 col-12">
        <el-form-item
          :label="L10n('html-2')"
          prop="html2"
          class="material-style"
        >
          <skill-editor
            :model.sync="form.html2"
            @blur="updateModelItem('html2', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-6 col-12">
        <el-form-item
          :label="L10n('html-3')"
          prop="html3"
          class="material-style"
        >
          <skill-editor
            :model.sync="form.html3"
            @blur="updateModelItem('html3', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormContents',
  mixins: [Form],
  components: {
    'skill-editor': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/SkillEditor')
  },
  props: {
    isNew: { type: Boolean }
  },
  computed: {
    disabledContentKey () {
      return !this.isNew
    }
  },
  methods: {
    inputContentKey (value) {
      this.form.contentKey = String(value).trim()
    }
  }
}
</script>
